import { Box, Stack, Typography, useTheme } from "@mui/material";
import { KbFileSection, KbFolderSection } from "./KbSection";
import {
  useNavigate,
  useOutletContext,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { KbBreadcrumbs } from "./KbBreadcrumb";

import { Dispatch, SetStateAction, useEffect, useMemo } from "react";
import {
  filterData,
  generateBreadcrumbs,
  generateKbFilesAndFolders,
} from "../helpers";
import { useAtomValue } from "jotai";
import { folderMap, filtersObj } from "../store";

import { KbNoDataScreen } from "./KbNoDataScreen";

export const KbFolderView = () => {
  const folderMapValue = useAtomValue(folderMap);
  const filters = useAtomValue(filtersObj);
  const { setTitle, folderId } = useOutletContext<{
    setTitle: Dispatch<SetStateAction<string>>;
    folderId: string;
  }>();

  const folderList = useMemo(
    () =>
      filterData({
        filters,
        // @ts-ignore
        kbData: folderMapValue.get(folderId) || [],
      }),
    [folderMapValue, folderId, filters],
  );

  useEffect(() => {
    // @ts-ignore
    setTitle(folderList?.name || "");
  }, [folderList]);
  const { files, folders } = generateKbFilesAndFolders(
    // @ts-ignore
    folderList?.children || [],
  );

  const breadcrumbItemsData = generateBreadcrumbs(folderId, folderMapValue);
  return (
    <Stack>
      <Box pl="32px" pt="4px">
        <KbBreadcrumbs path={breadcrumbItemsData} />
      </Box>
      {folders && folders.length > 0 && (
        <KbFolderSection folders={folders || []} />
      )}
      {files && files.length > 0 && (
        <KbFileSection isSelectable files={files || []} />
      )}
      {(!folders || (folders && folders?.length === 0)) &&
        (!files || files?.length === 0) && <KbNoDataScreen />}
    </Stack>
  );
};
